// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__872bT","root_inner":"Auth_root_inner__Q6SUt","logoWrapper":"Auth_logoWrapper__dDPdj","auth":"Auth_auth__xeWXX","search_table":"Auth_search_table__xmzsB"};